<template>
  <v-navigation-drawer
    v-show="hasFranquia"
    :value="menuOpen"
    @input="handleMenuToggle"
    color="grey lighten-5"
    app
  >
    <v-list-item class="px-2 py-5">
      <v-list-item-content>
        <v-list-item-title class="d-flex justify-center" id="menu.logo">
          <router-link :to="{ name: 'home' }">
            <img src="/img/logo.png" class="mb-5" width="100" />
          </router-link>
        </v-list-item-title>

        <v-list-item-subtitle class="d-flex justify-center" id="menu.ano_selector">
          <e-ano-selector class="" />
          <!-- <e-franquia-selector class="ml-2" /> -->
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-group
        v-for="item in menu.items.filter(
          (item) =>
            item.exibir && item.children.filter((child) => $can(child.permissions)).length > 0
        )"
        :key="item.title"
        :id="item.id"
        v-model="item.active"
        no-action
        :append-icon="item.children && item.children.length > 0 ? undefined : ''"
        :prepend-icon="item.icon"
        @click="() => (item.to ? $router.push(item.to) : undefined)"
      >
        <template v-slot:activator>
          <!-- <v-list-item
                :to="item.to || undefined"
                link
              > -->
          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
          </v-list-item-content>
          <!-- </v-list-item
              > -->
        </template>
        <v-list-item
          v-for="child in item.children"
          v-show="$can(child.permissions)"
          :key="child.title"
          :id="child.id"
          :to="child.to"
          :href="child.href"
          :target="child.target"
        >
          <v-divider v-if="child.type === 'spacer'" />
          <v-list-item-content v-if="child.type !== 'spacer'">
            <v-list-item-title v-text="child.title" />
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <!-- </v-list-group> -->
    <!-- </v-list> -->
    <template v-slot:append>
      <e-situacao-caixa v-if="exibirFinanceiro" />
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import EAnoSelector from "@/Pages/Templates/components/EAnoSelector.vue";
import ESituacaoCaixa from "@/Pages/Templates/components/ESituacaoCaixa.vue";

const exibirFinanceiro = process.env.VUE_APP_ATIVAR_FINANCEIRO === "true";
export default {
  name: "MainTemplate",
  components: {
    EAnoSelector,
    ESituacaoCaixa,
  },
  watch: {
    user: {
      immediate: true,
      handler(newUser) {
        if (newUser && !newUser?.franquia?.id) {
          this.$toast.danger("Você não possui uma franquia vinculada.");
        }
      },
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquias"]),
    ...mapGetters("MainTemplate", ["menuOpen"]),
    hasFranquia() {
      return !!this.user?.franquia?.id;
    },
    menu() {
      return {
        items: [
          {
            id: "menu.inicio",
            icon: "mdi mdi-home",
            title: "Início",
            exibir: true,
            children: [
              {
                id: "menu.ir_para_inicio",
                title: "Ir para Início",
                to:
                  (this.user ? this.user.roleName : "") === "professor"
                    ? {
                        name: "acessoProfessor.home",
                      }
                    : {
                        name:
                          (this.user ? this.user.roleName : "") === "prof-auxiliar"
                            ? "acessoProfessor.home"
                            : "home",
                      },
                icon: "",
              },
              {
                id: "menu.ir_para_notifiq",
                title: "Ir para notifiq",
                to: {
                  name: "notifiq.index",
                },
                permissions: ["notifiq.load"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.agenda",
            icon: "mdi mdi-book-education",
            title: "Agenda",
            exibir: (this.user ? this.user.roleName : "") === "aluno",
            children: [
              {
                id: "menu.ir_para_agendas",
                title: "Ir para Agendas",
                to: {
                  name: "agenda.aluno",
                },
                icon: "",
              },
            ],
          },
          {
            id: "menu.avisos",
            icon: "mdi mdi-comment-alert",
            title: "Avisos",
            exibir: true,
            permissions: ["alunos.detalhes"],
            children: [
              // {
              //   title: "Meus avisos",
              //   to: {
              //     name: "avisos.portal",
              //   },
              //   icon: "",
              // },
              {
                id: "menu.ir_para_avisos",
                title: "Ir para Avisos",
                to: {
                  name:
                    (this.user ? this.user.roleName : "") === "aluno"
                      ? "avisos.portal"
                      : "avisos.index",
                },
                permissions: ["avisos.*", "avisos.listar", "alunos.detalhes"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.matriculas",
            icon: "mdi mdi-account-school",
            title: "Matrículas",
            exibir: true,
            children: [
              {
                id: "menu.ver_matriculas",
                title: "Ver Matrículas",
                to: { name: "matriculas" },
                permissions: ["matriculas.matricular", "matriculas.*"],
                icon: "",
              },
              // { title: "Adicionar matricula", to: "#", icon: "" },
              {
                id: "menu.ver_alunos",
                title: "Ver Alunos",
                to: { name: "alunos" },
                permissions: ["alunos.criarAluno", "alunos.*"],
                icon: "",
              },
              {
                id: "menu.pesquisa_avancada",
                title: "Pesquisa avançada",
                to: { name: "alunos-pesquisa-avancada" },
                permissions: ["alunos.criarAluno", "alunos.*"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.turmas",
            icon: "mdi mdi-school",
            title: "Turmas",
            exibir: true,
            children: [
              {
                id: "menu.ver_turmas",
                title: "Ver turmas",
                to: { name: "turmas" },
                permissions: ["turmas.criarTurma", "turmas.*"],
                icon: "",
              },
              {
                id: "menu.gestao_anos",
                title: "Gestão de anos",
                to: { name: "series" },
                icon: "fa fa-bookmark",
                permissions: ["series.*", "series.criar"],
              },
              {
                id: "menu.gestao_disciplinas",
                title: "Componentes Curriculares",
                to: { name: "disciplinas" },
                icon: "fa fa-bookmark",
                permissions: ["disciplinas.*", "disciplinas.criarDisciplina"],
              },
            ],
          },
          {
            id: "menu.planos",
            icon: "mdi mdi-note-text",
            title: "Planos",
            exibir:
              (this.user ? this.user.roleName : "") !== "professor" &&
              (this.user ? this.user.roleName : "") !== "prof-auxiliar",
            children: [
              {
                id: "menu.listar_planos",
                title: "Listar planos",
                to: { name: "gestoesDeAulas.planos" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                id: "menu.listar_planos_infantis",
                title: "Listar planos infantis",
                to: { name: "gestoesDeAulas.planosInfantil" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
            ],
          },
          {
            id: "menu.diario_online",
            icon: "mdi-human-male-board-poll",
            title: "Diário online",
            exibir: this.exibirDiarioOnline,
            children: [
              {
                id: "menu.diario_online.listar_todos",
                title: "Listar todos",
                to: { name: "gestoesDeAulas" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
              {
                id: "menu.diario_online.gestao_geral",
                title: "Gestão geral",
                to: { name: "gestoesDeAulas.geral" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.gestoesGeral"],
              },
              {
                id: "menu.diario_online.agendas",
                title: "Agendas",
                to: { name: "agenda.index" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.listar"],
              },
            ],
          },
          // aqui
          {
            id: "menu.diario_auxiliares",
            icon: "mdi-human-male-board",
            title: "Diário de Auxiliares",
            exibir: this.exibirDiarioAuxiliares,
            children: [
              {
                id: "menu.diario_auxiliares.listar_todos",
                title: "Listar todos",
                to: { name: "gestoesDeAulasAuxiliares" },
                icon: "",
                permissions: ["gestoesDeAulas.*", "gestoesDeAulas.criar", "gestoesDeAulas.listar"],
              },
            ],
          },

          {
            id: "menu.relatorios",
            icon: "mdi mdi-chart-box",
            title: "Relatórios",
            exibir: true,
            children: [
              {
                id: "menu.ver_todos_relatorios",
                title: "Ver todos",
                to: {
                  name: `relatorios`,
                  params: { franquiaId: this.user.franquia.id },
                },
                icon: "",
                permissions: ["relatorios.*"],
              },
            ],
          },
          {
            id: "menu.usuarios",
            icon: "mdi mdi-account-switch",
            title: "Usuários",
            exibir: true,
            children: [
              {
                id: "menu.ver_professores",
                title: "Ver Professores",
                to: { name: "professores" },
                icon: "fa fa-user-tie",
                permissions: ["users.*"],
              },
              {
                id: "menu.bloqueios_liberacoes",
                title: "Bloqueios/Liberações",
                to: { name: "usuarios.listaDeUsuariosParaBloquearLiberar" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
              },
              {
                id: "menu.outros_usuarios",
                title: "Outros",
                to: { name: "usuarios" },
                icon: "fa fa-bookmark",
                permissions: ["users.*"],
              },
            ].filter((child) => {
              if (this.user?.roleName === "secretario") {
                return child.title === "Outros";
              }
              return true;
            }),
          },
          {
            id: "menu.financeiro",
            icon: "mdi mdi-cash-multiple",
            title: "Financeiro",
            exibir: exibirFinanceiro,
            children: [
              {
                id: "menu.mensalidades",
                title: "Mensalidades",
                to: { name: "mensalidades" },
                permissions: "financeiro.baixarParcela",
                icon: "",
              },
              {
                id: "menu.gestao_caixas",
                title: "Gestão de Caixas",
                to: { name: "caixas" },
                permissions: "caixas.abrir",
                icon: "",
              },
            ],
          },
          {
            id: "menu.administracao",
            icon: "mdi mdi-account-network",
            title: "Administração",
            exibir: true,
            children: [
              {
                id: "menu.franquias",
                title: "Franquias",
                to: { name: "franquias" },
                permissions: ["franquias.*", "franquias.criarFranquia"],
                icon: "",
              },
              {
                id: "menu.administracao.auditoria",
                title: "Auditoria",
                to: { name: "auditoria" },
                permissions: ["auditoria.*"],
                icon: "",
              },
              {
                id: "menu.circuito_notas",
                title: "Circuito De Notas",
                to: { name: "circuito-notas" },
                permissions: ["franquias.circuitoAcesso"],
                icon: "",
              },
              {
                id: "menu.bolsa_familia",
                title: "Bolsa Família",
                to: { name: "bolsa-familia" },
                permissions: ["bolsaFamilia.*"],
                icon: "",
              },
              {
                id: "menu.calculadora_fundeb",
                title: "Calculadora FUNDEB",
                to: { name: "fundeb.calculadora" },
                permissions: ["franquias.*"],
                exibir: this.user.roleName === "admin" || this.user.roleName === "super-admin",
                icon: "",
              },
            ],
          },
          {
            id: "menu.calendario_letivo",
            icon: "mdi mdi-calendar-check", // Ícone para o item principal
            title: "Calendário Letivo",
            exibir: true,
            children: [
              {
                id: "menu.calendario_letivo.calendario",
                title: "Calendário",
                to: { name: "calendario-letivo.create" },
                permissions: ["calendarioLetivo.*", "calendarioLetivo.calendariosIndex"],
                icon: "",
              },
              {
                id: "menu.calendario_letivo.adicionar_categoria",
                title: "Adicionar Categoria",
                to: { name: "eventos-calendario-letivo" },
                permissions: ["calendarioLetivo.*", "eventosCalendarioLetivo.eventosCreate"],
                icon: "",
              },
            ],
          },
          {
            icon: "mdi-bell-ring",
            title: "Notifiq",
            exibir: true,
            children: [
              {
                title: "Presença no Notifiq",
                to: { name: "notifiq.indexNotifiq" },
                // permissions: ["notifiq.listaPresencasNotifiq"],
                icon: "",
              },
            ],
          },
          {
            id: "menu.ajuda_tutorial",
            icon: "mdi mdi-help",
            title: "Ajuda e tutorial",
            exibir: true,
            children: [
              {
                id: "menu.tutoriais",
                title: "Tutoriais",
                href: "https://epublic.tawk.help/",
                target: "_blank",
              },
            ],
          },
        ],
        width: "250px",
      };
    },
  },
  async mounted() {
    this.exibirDiarioOnline = await this.$checkUserTemGestao("regular");
    this.exibirDiarioAuxiliares = await this.$checkUserTemGestao("auxiliar");
    // this.$Tawk.$setOnLoadFunction(() => this.$Tawk.$showWidget());
  },
  data() {
    return {
      selectedItem: 0,
      openAtualizarSenhaModal: false,
      openSelecionarFranquiaModal: false,
      exibirFinanceiro,
      exibirDiarioOnline: true,
      exibirDiarioAuxiliares: true,
    };
  },
  methods: {
    handleMenuToggle(newValue) {
      if (newValue && !this.hasFranquia) {
        this.$toast.danger("Você não possui uma franquia vinculada.");
        return;
      }
      this.$store.commit("MainTemplate/setMenuOpen", newValue);
    },

    toggleMenu() {
      this.handleMenuToggle(!this.menuOpen);
    },
  },
};
</script>
